module.exports = __webpack_public_path__ + "static/ushuaia-agua-274a21fde28f8f28322e4e66f7c31fb8.jpg";